import React from 'react';
import type { CategoryOption } from './FilterBar';

interface CategoryFilterProps {
  value: string;
  onChange: (value: string) => void;
  categories: CategoryOption[];
  className?: string;
}

/**
 * The category "capsule" row (All / Licenses / Mining / …), extracted from FilterBar so
 * it can be rendered — and made sticky — independently of the search bar and results count.
 */
export const CategoryFilter: React.FC<CategoryFilterProps> = ({ value, onChange, categories, className }) => {
  return (
    <div className={`flex items-center gap-2 overflow-x-auto scrollbar-hide ${className ?? ''}`}>
      {categories.map((type) => (
        <button
          key={type.value}
          onClick={() => onChange(type.value)}
          className={`px-4 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
            value === type.value
              ? 'bg-foreground text-background'
              : 'bg-secondary text-muted-foreground hover:bg-secondary/80'
          }`}
        >
          {type.label}
        </button>
      ))}
    </div>
  );
};
